.helperTextStyle {
	margin-top: 5px;
	text-align: left;
	font-size: 0.75rem;
	white-space: pre-wrap;
	background-color: #fdecea;
	padding: 6px 16px;
	font-family: Helvetica;
	display: flex;
	border-radius: 4px;
	padding-top: 6px 16px;
	letter-spacing: 0.01071em;
	box-shadow: none;
}
.alertStyle {
	margin-top: 5px;
	text-align: left;
	font-size: 0.75rem !important;
	color: #f44336 !important;
	white-space: pre-wrap;
}
.inputLabel {
	color: black !important;
	font-family: Helvetica !important;
	letter-spacing: 0.01071em !important;
}
